import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, Row, Col, Label, Button, Input, Spinner } from 'reactstrap';
import useReactSelectCustomStyle from '../../hooks/useReactSelectCustomStyle';
import Flatpickr from 'react-flatpickr';
import Select from "react-select";
import moment from 'moment';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { addClientLicenseAPI } from '../../apiConfig/apiCall';
import { useDispatch } from 'react-redux';
import { getClientLicenseList } from '../../slices/LicenseList/thunk';

export default function AddLicenseModal({ addLicenseModal, handleAddLicenseModal }) {

    const params = useParams();
    const dispatch = useDispatch();

    const selectBoxCustomStyles = useReactSelectCustomStyle();

    const [submittingForm, setSubmittingForm] = useState(false);

    const typeOptions = [
        { value: 'Annual', label: 'Annual' },
        { value: 'Monthly', label: 'Monthly' },
    ];

    const productOptions = [
        { value: 'Xzlenz', label: 'Xzlenz' },
        { value: 'Scanbit', label: 'Scanbit' },
        { value: 'Reporting Tool', label: 'Reporting Tool' },
        { value: 'Dhanush Guard', label: 'Dhanush Guard' },
        { value: 'Scanbit', label: 'Scanbit' },
        { value: 'Xeonpay', label: 'Xeonpay' },
    ];

    const initialFormData = {
        startDate: moment().format('YYYY-MM-DD'),
        dueDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        productName: "",
        type: null,
        overview: "",
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (field, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const resetFormFields = () => {
        setFormData(initialFormData);
    };

    const handleSubmitAddLicense = async (e) => {
        e.preventDefault();
        if (submittingForm) return;

        try {
            const { startDate, dueDate, productName, type, overview } = formData;

            if (!productName || !type || !overview) {
                toast.error("All fields are required.");
                return;
            }

            const dataToSubmit = {
                clientCompanyId: Number(params.id),
                startDate,
                dueDate,
                productName,
                type,
                overview,
            };
            const apiResponse = await addClientLicenseAPI(dataToSubmit);
            if (apiResponse.status === 201) {
                handleAddLicenseModal();
                toast.success(apiResponse.data);
                dispatch(getClientLicenseList(params.id));
            }
        } catch (error) {
            console.error('Error sending data:', error);
            toast.error('An error occurred while adding the license');
        } finally {
            setSubmittingForm(false);
        }
    };

    return (
        <Modal isOpen={addLicenseModal} toggle={handleAddLicenseModal} backdrop={'static'}>
            <ModalHeader toggle={handleAddLicenseModal}>Add License</ModalHeader>
            <ModalBody>
                <Form>
                    <Row className="gy-3">
                        <Col lg={6}>
                            <div>
                                <Label htmlFor="productName" className="form-label">Product Name</Label>
                                <Select
                                    value={formData.productName ? { value: formData.productName, label: formData.productName } : null}
                                    onChange={(option) => handleChange('productName', option?.value || "")}
                                    options={productOptions}
                                    styles={selectBoxCustomStyles}
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <Label htmlFor="type" className="form-label">Type</Label>
                                <Select
                                    value={formData.type ? typeOptions.find(option => option.value === formData.type) : null}
                                    onChange={(option) => handleChange('type', option?.value || null)}
                                    options={typeOptions}
                                    styles={selectBoxCustomStyles}
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <Label htmlFor="startDate" className="form-label">Start Date</Label>
                                <Flatpickr
                                    className="form-control"
                                    options={{ dateFormat: "Y-m-d" }}
                                    value={formData.startDate}
                                    onChange={(date) => handleChange('startDate', moment(date[0]).format('YYYY-MM-DD'))}
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div>
                                <Label htmlFor="dueDate" className="form-label">Due Date</Label>
                                <Flatpickr
                                    className="form-control"
                                    options={{ dateFormat: "Y-m-d" }}
                                    value={formData.dueDate}
                                    onChange={(date) => handleChange('dueDate', moment(date[0]).format('YYYY-MM-DD'))}
                                />
                            </div>
                        </Col>
                        <Col lg={12}>
                            <div>
                                <Label htmlFor="overview" className="form-label">Overview</Label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    id="overview"
                                    value={formData.overview}
                                    onChange={(e) => handleChange('overview', e.target.value)}
                                />
                            </div>
                        </Col>
                        <Col lg={12}>
                            {submittingForm ? (
                                <Button color="primary" className="me-2" type="button" disabled>
                                    <Spinner size="sm"> Loading... </Spinner>
                                </Button>
                            ) : (
                                <Button
                                    color="primary"
                                    type="submit"
                                    className="me-2"
                                    disabled={submittingForm}
                                    onClick={handleSubmitAddLicense}
                                >
                                    Add
                                </Button>
                            )}
                            <Button
                                color="secondary"
                                type="reset"
                                disabled={submittingForm}
                                onClick={resetFormFields}
                            >
                                Reset
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    );
}